namespace gotoAndPlay {

    $(document).on('change', '.multiselect-dropdown__input--radio', function(e: JQuery.Event) {
        $(e.currentTarget).closest('.multiselect-dropdown').find('.multiselect-dropdown__select').text($(this).attr('data-title'));
        $(e.currentTarget).closest('.multiselect-dropdown').find('.js-trigger').trigger('click');
    });

    $(document).on('change', '.multiselect-dropdown__input--check', function(e: JQuery.Event) {
        var checked = $(e.currentTarget).closest('.multiselect-dropdown__list').find('.multiselect-dropdown__input--check:checked').length;
        $(e.currentTarget).closest('.multiselect-dropdown').find('.multiselect-dropdown__select span').remove();

        if(checked) {
            $(e.currentTarget).closest('.multiselect-dropdown').find('.multiselect-dropdown__select').append('<span>'+checked+'</span>');
        }
    });
}
